import type { ChangeEvent, ReactNode } from 'react';

interface PackageNameFieldBaseProps {
  value: string;
  disabled?: boolean;
  required?: boolean;
  error?: string | null;
  showError?: boolean;
  description?: string;
  inputClassName: string;
  afterInput?: ReactNode;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

export function PackageNameFieldBase({
  value,
  disabled,
  required,
  error,
  showError,
  description = 'Android package name in reverse domain format (e.g., com.example.app)',
  inputClassName,
  afterInput,
  onChange,
}: PackageNameFieldBaseProps) {
  return (
    <div>
      <div className="font-bold text-white text-sm">Package Name</div>
      <div className="text-sm text-neutral-400">{description}</div>
      <div className="relative mt-1">
        <input
          type="text"
          name="packageName"
          aria-label="Package Name"
          value={value}
          onChange={onChange}
          placeholder="com.example.app"
          required={required}
          disabled={disabled}
          className={inputClassName}
        />
        {afterInput}
      </div>
      {error && showError && (
        <div className="mt-1 text-sm text-red-500">{error}</div>
      )}
    </div>
  );
}
